import { useTranslation } from 'react-i18next';

export const keyPrefix = 'block_user';
export const useBlockUserTranslation = () => useTranslation('features', { keyPrefix });

export const ruRu = ({
  [keyPrefix]: {
    button: 'Заблокировать',
    toast_success: 'Пользователь успешно заблокирован',
    toast_error: 'Не удалось заблокировать пользователя',
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    button: 'Block',
    toast_success: 'User successfully blocked',
    toast_error: 'Failed to block user',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    button: 'Bloquear',
    toast_success: 'Usuário bloqueado com sucesso',
    toast_error: 'Não foi possível bloquear o usuário',
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    button: 'Bloquear',
    toast_success: 'Usuario bloqueado con éxito',
    toast_error: 'No se pudo bloquear al usuario',
  },
}) as Record<string, unknown>;
